import LinearProgress from "@mui/material/LinearProgress";
import { DataGrid } from "@mui/x-data-grid";
import React, { useState, ChangeEvent } from "react";

type props = {
  columns: any;
  rows: any;
  count?: number;
  page?: any;
  onPageChange?: any;
  loading?: any;
  getRowId?: (row: any) => any;
};

export default function TableComponent({
  rows,
  columns,
  count,
  page,
  onPageChange,
  loading,
  getRowId,
}: props) {
  const [searchValue, setSearchValue] = useState("");

  const handleSearch = (value: string) => {
    setSearchValue(value);
  };

  return (
    <DataGrid
      hideFooter
      getRowId={getRowId || ((row) => row._id)}
      slots={{
        loadingOverlay: (props) => (
          <LinearProgress style={{ height: 4 }} {...props} />
        ),
      }}
      localeText={{
        noRowsLabel: "No data found",
      }}
      loading={loading}
      rows={rows}
      columns={columns}
      disableRowSelectionOnClick
      disableColumnMenu
      disableColumnFilter
      slotProps={{
        toolbar: {
          value: searchValue,
          clearSearch: () => handleSearch(""),
          onChange: (event: ChangeEvent<HTMLInputElement>) =>
            handleSearch(event.target.value),
        },
      }}
      sx={{
        ".MuiDataGrid-iconButtonContainer": {
          width: "auto",
          visibility: "visible",
        },
        ".MuiDataGrid-sortIcon": {
          opacity: "inherit !important",
        },
      }}
      rowHeight={70}
    />
  );
}
